import { makeAutoObservable } from 'mobx';
import { onFCP, onLCP, type FCPMetric, type LCPMetric } from 'web-vitals';

import { InitializationError } from '../../components/ErrorPage/Errors';

interface IWebPerformanceModel {
	readonly initializeOnce: () => void;
	readonly isLcpComplete: boolean;
	readonly isFcpComplete: boolean;
}

export class WebPerformanceModel implements IWebPerformanceModel {
	private _initialized = false;
	private _isLcpComplete = false;
	private _isFcpComplete = false;

	private constructor() {
		makeAutoObservable(this);
	}

	static readonly create = (): WebPerformanceModel => new WebPerformanceModel();

	get isLcpComplete() {
		return this._isLcpComplete;
	}

	get isFcpComplete() {
		return this._isFcpComplete;
	}

	readonly setIsLcpComplete = (isLcpComplete: typeof this.isLcpComplete) => {
		this._isLcpComplete = isLcpComplete;
	};

	readonly setIsFcpComplete = (isFcpComplete: typeof this.isFcpComplete) => {
		this._isFcpComplete = isFcpComplete;
	};

	readonly setIsInitialized = () => {
		this._initialized = true;
	};

	readonly initializeOnce = () => {
		if (this._initialized) {
			return;
		}

		this.initialize();
	};

	readonly initialize = () => {
		const { setIsInitialized, setIsLcpComplete, setIsFcpComplete, _initialized: isInitialized } = this;

		if (isInitialized) {
			throw new InitializationError('WebPerformanceModel is already initialized');
		}

		setIsInitialized();

		onLCP(function updateIsLcpComplete(_metric: LCPMetric): void {
			setIsLcpComplete(true);
		});

		onFCP(function updateIsFcpComplete(_metric: FCPMetric): void {
			setIsFcpComplete(true);
		});
	};
}

let maybeWebPerformanceModel: WebPerformanceModel | null = null;
export function getOrCreateWebPerformanceModel(): WebPerformanceModel {
	maybeWebPerformanceModel ??= WebPerformanceModel.create();
	return maybeWebPerformanceModel;
}
